import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { CustomSnackBarComponent } from "./custom-snack-bar.component";

type messageType = "success" | "error" | "neutral" | "warning" | "info";

@Injectable({ providedIn: "root" })
export class CustomSnackBarService {

  private queue: MatSnackBarConfig[] = [];
  private isShowing = false;
  private horizontalPosition: MatSnackBarHorizontalPosition = "end";
  private verticalPosition: MatSnackBarVerticalPosition = "bottom";
  private duration: number = 5;

  constructor(private messageBar: MatSnackBar) {}

  public open(
    message: string,
    type: messageType,
    duration?: number,
    horizontalPosition?: MatSnackBarHorizontalPosition,
    verticalPosition?: MatSnackBarVerticalPosition
  ) {
    const config = new MatSnackBarConfig();
    config.duration = (duration ?? this.duration) * 1000;
    config.panelClass = 'custom-message';
    config.horizontalPosition = horizontalPosition ?? this.horizontalPosition;
    config.verticalPosition = verticalPosition ?? this.verticalPosition;
    config.data = { message, type };
    this.queue.push(config);
    this.showNext();
  }

  private showNext() {
    if (this.isShowing || this.queue.length === 0) return;

    this.isShowing = true;
    const config = this.queue.shift()!;
    const snackRef = this.messageBar.openFromComponent(CustomSnackBarComponent, config);

    snackRef.afterDismissed().subscribe(() => {
      this.isShowing = false;
      this.showNext();
    });
  }
}